<!--新客列表-->
<template>
    <div>
        <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
            <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{ checkedRegion.name }}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
            </div>
            <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{ checkedStore.name }}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
            </div>
        </div>
        <div class="date-box flex-between flex-y-center mb-10">
            <div class="font26" style="color:#66757F">{{ dateTime }}<span class="font40 Blacks bold">{{ total }}</span><span class="font28 Blacks">人</span></div>
        </div>
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex flex-y-center flex-start" v-if="postId == 1 || postId == 11 || postId == '1472787652026765367'">
            <div class="select-item mr-50 flex-between flex-y-center" @click="selectEmployeePopup">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad" :offset="20" :immediate-check="false">
                    <div class="customer-list" v-for="(item, index) in birthList" :key="index" @click="toDetail(item.custId, item.custMobile)">
                        <div class="top-box flex-row">
                            <img class="customerHeadPortrait" referrerpolicy="no-referrer" alt="" :src="item.custImg ? item.custImg : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                            <div class="customer-info flex-1">
                                <div class="flex-1 flex-y-center flex-start">
                                    <div class="customer-name">{{ item.custName }}</div>
                                    <img class="card-icon" referrerpolicy="no-referrer" v-if="item.cardImg" :src="item.cardImg" alt="" />
                                    <div class="customer-name flex-1 flex-y-center" style="display:block;text-align:right;"> <img class="arrow_right" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                                    </div>
                                </div>
                                <div class="infoName">
                                    {{ dimension == 2 ? '主诊' : '健康顾问' }}：{{ item.attendingName }}
                                </div>
                                <div class="infoName">
                                    最近到诊{{ dimension == 2 ? '门诊' : '门店' }}：{{ item.storeName }} </div>
                                <div class="infoName">
                                    最近到诊时间：{{ item.diagnoseDate }} </div>
                            </div>
                        </div>
                        <div class="customer-remark flex-between flex-col" v-if="item.prodName && item.expiredTime">
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">生日券：</span>
                                <span class="sale-box flex-1">{{ item.prodName }}</span>
                            </div>
                            <div class="flex-between flex-y-center mt10">
                                <span class="sale-name">到期时间：</span>
                                <span class="sale-box flex-1">{{ item.expiredTime }}</span>
                            </div>
                        </div>
                        <img class="used-icon" referrerpolicy="no-referrer" alt="" v-if="item.prodName && item.expiredTime && item.useStatus == 3" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/used-icon.png" />
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker :title="empTitle" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange"></picker>
            </van-popup>
            <!-- 区经区总 切换区域 -->
            <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
            </van-popup>
            <!-- 区经区总 切换门店 -->
            <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Search, Toast } from "vant";
    import Picker from '@/components/Picker';
    import { getCookie } from '@/utils'
    import { openEnterpriseChat, navigateToAddCustomer } from '@/utils/wxCodeAuth'
    import { mapState } from 'vuex'
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'



    export default {
        name: "newCustomers",
        components: {
            [Search.name]: Search, Picker
        },
        inject: ['reload'],
        data() {
            return {
                showEmployeePopup: false,// 选择员工弹窗
                showCardPopup: false,// 选择卡弹窗
                searchStr: '',  // 搜索条件
                page: 1,       // 当前页
                limit: 10,       // 每页多少条
                total: 0,     // 列表总条数
                birthList: [

                    { name: 1, createDate: 2 }
                ],    // 列表
                loading: false,    // 加载
                finished: false,    // 结束加载
                refreshing: false,   // 刷新
                cardList: [],// 卡列表
                checkedCard: null,//所选卡
                employeeList: [], // 员工
                checkedEmployee: null,//所选员工
                postId: 0, // 岗位
                dateTime: "",
                empTitle: '',
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                dimension: 0, //区分生美医美 1 生美 2 医美 3 抗衰
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
            this.empTitle = this.dimension == 2 ? '主诊人' : '健康顾问' // 选择器标题

            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    // 如果当前没有选择门店记录，则进入大区页面
                    if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                        this.$router.replace({
                            name: "newCustomersRegionPage"
                        });
                    }
                }
                this.init()
            })
        },
        methods: {
            async init() {
                await this.getEmpList()
                this.onLoad()
            },
            onLoad() {
                this.loading = true
                let params = {
                    keysword: this.searchStr,
                    limit: this.limit,
                    page: this.page,
                    attendingId: this.checkedEmployee && this.checkedEmployee.id,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                request({
                    url: "/new/customer/page",
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.dateTime = res.data.dateTime
                        this.birthList = this.page == 1 ? res.data.list : this.birthList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;

                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        this.refreshing = false;
                        if (this.birthList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 获取员工列表
            getEmpList() {
                return request({
                    url: "/sys/params/selectByStoreTreasure",
                    method: "get",
                    params: {
                        storeId: this.checkedStore.id,
                        id: this.checkedStore.id
                    }
                })
                    .then((res) => {
                        this.employeeList = res.data
                        this.checkedEmployee = this.employeeList[0] //默认全部

                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 获取卡列表
            getCardList() {
                return request({
                    url: "/dict/type/cardLevel",
                    method: "get",
                })
                    .then((res) => {
                        this.cardList = res.data
                        this.checkedCard = this.cardList[0] //默认全部

                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            //搜索
            onSearch() {
                this.page = 1
                this.onLoad();
            },
            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.birthList = [];
                this.refreshing = false;
                this.onLoad();
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh()
            },
            // 弹窗
            selectEmployeePopup() {
                this.showEmployeePopup = true
            },
            selectCardPopup() {
                this.showCardPopup = true
            },
            selectTimePopup() {
                this.showTimePopup = true
            },
            // 筛选相关
            handleDate(id, begin, end) {
                this.showTimePopup = false
                this.dateType = id
                if (!id) {
                    this.beginMonth = begin
                    this.endMonth = end
                } else {
                    this.beginMonth = ''
                    this.endMonth = ''
                }
                this.onRefresh()
            },
            onEmployeeChange(data) {
                this.checkedEmployee = data
                this.showEmployeePopup = false
                this.onRefresh()
            },
            onCardChange(data) {
                this.showCardPopup = false
                this.checkedCard = data
                this.onRefresh()
            },
            //查看详情
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
            // 去打电话
            toContact(phone) {
                window.location.href = `tel:${phone}`;
            },
            //打开会话
            toOpenWechat(item) {
                if (item.wxExternalUserid && item.isWxContact == 1)   //是好友打开会话
                    openEnterpriseChat('', item.wxExternalUserid, '', '')
                else
                    //不是好友d，打开添加客户页面
                    navigateToAddCustomer('')
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id == 0 || data.id == -1) {
                        this.$router.replace({
                            name: "newCustomersRegionPage"
                        });
                    } else {
                        this.reload();
                    }
                })
            },
        },
    };
</script>

<style scoped lang="less">
    ::-webkit-scrollbar {
        display: none;
    }

    .mr-50 {
        margin-right: 50px;
    }

    .date-box {
        margin-top: 30px;
        margin-right: 30px;
        margin-left: 30px;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    .list-box {
        width: 100%;
        height: calc(100vh - 245px);
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
        padding: 30px 30px 30px 30px;
    }

    .customer-list {
        width: 690px;
        background: #fafafe;
        border-radius: 20px;
        margin-bottom: 20px;
        padding: 30px 0;
        position: relative;

        .used-icon {
            width: 196px;
            height: 196px;
            position: absolute;
            right: 32px;
            bottom: 38px;
        }

        .top-box {
            padding: 0 20px 0 20px;
        }

        .customer-name {
            min-width: 60px;
            font-size: 30px;
            color: #35434c;
            font-weight: 700;
        }

        .churn-time {
            height: 37px;
            font-size: 26px;
            color: #66757f;
            line-height: 37px;
            margin-top: 14px;
        }

        .emp-name {
            margin-top: 4px;
        }

        .infoName {
            font-size: 28px;
            color: #a0acb5;
            margin-top: 4px;
        }

        .nursing-edit-box {
            margin: 37px 0 0 163px;
        }

        .card-icon {
            width: 90px;
            height: 34px;
            margin-left: 10px;
        }

        .arrow_right {
            width: 15px;
            height: 26px;
            margin-left: 20px;
        }

        .icon-item {
            width: 46px;
            height: 46px;
        }

        .chat-icon {
            margin-right: 40px;
        }

        .cake-icon {
            width: 28px;
            height: 26px;
            margin-right: 11px;
        }

        .card-image {
            height: 34px;
            width: 90px;
            margin: 24px 0 0 10px;
        }

        .customerHeadPortrait {
            width: 90px;
            height: 90px;
            border-radius: 45px;
            margin-right: 20px;
        }

        .customer-remark {
            padding: 30px 20px 0 20px;
            margin-top: 20px;
            border-top: 1px solid #d7d7d7;
        }

        .sale-name {
            min-width: 100px;
            height: 40px;
            font-size: 28px;
            color: #a0acb5;
            line-height: 40px;
        }

        .sale-box {
            font-size: 28px;
            color: #a0acb5;
            line-height: 40px;
        }

        .sale-number {
            height: 45px;
            font-size: 28px;
            color: #35434c;
            line-height: 45px;
            margin-top: 28px;
            min-width: 40px;
            font-weight: 700;
        }
    }

    .select-box {
        margin-left: 30px;
        margin-top: 10px;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .mt10 {
        margin-top: 10px;
    }

    .store-box {
        padding: 30px 30px 0 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    :deep(.van-search) {
        padding: 19px 30px 19px 30px;
    }

    :deep(.search-button .van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 0 !important;
        margin-right: 0 !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }
</style>
